<template>
	<div class="layout">
		<div class='head'>
			<div class="uni-row head-1">
				<div class="flex-item-20" @click="getAnalysisResult('日')"
					:style="{'border-bottom':currentDate == '日' ? '3px solid #ff6a7f':'none'}">日</div>
				<div class="flex-item-20" @click="getAnalysisResult('周')"
					:style="{'border-bottom':currentDate == '周' ? '3px solid #ff6a7f':'none'}">周</div>
				<div class="flex-item-20" @click="getAnalysisResult('月')"
					:style="{'border-bottom':currentDate == '月' ? '3px solid #ff6a7f':'none'}">月</div>
				<div class="flex-item-20" @click="getAnalysisResult('年')"
					:style="{'border-bottom':currentDate == '年' ? '3px solid #ff6a7f':'none'}">年</div>
				<div class="flex-item-20" @click="getAnalysisResult('自定义')"
					:style="{'border-bottom':currentDate == '自定义' ? '3px solid #ff6a7f':'none'}">
					<DatePicker
					        :open="pickerStatus"
					        confirm
					        type="daterange"
							@on-change="pickerChange"
							@on-clear="pickerClear"
							@on-ok="pickerOk"
							:transfer='true'>
					        自定义
					    </DatePicker>
				</div>
			</div>
			<div class="uni-row head-2">
				<div class="flex-item-20">
					<div class="label-view jxyd-a" :style="{'display':(currentDate!='自定义' && currentDate) ? 'inline':'none','fontsize':'6px'}" @click="lastDate(currentDate)">
						{{"上一"+currentDate}}
					</div>
				</div>
				<div class="flex-item-60" style="text-align: center;padding: 5px 0px;">
					{{searchItems.totalBusinessDate[0] +" 至 "+ searchItems.totalBusinessDate[1]}}
				</div>
				<div class="flex-item-20">
					<div class="label-view jxyd-a" :style="{'display':(currentDate!='自定义' && currentDate) ? 'inline':'none'}" @click="nextDate(currentDate)">
						{{"下一"+currentDate}}
					</div>
				</div>
			</div>
		</div>
		<div class="body">
			<div class="uni-row">
				<div class="flex-item-50">
					<div class="amount-box">
						<div class="amount-box-title">销售金额</div>
						<div class="text-overflow amount-box-amount">
							￥{{itemData.salesAmount}}
							<span class="amount-box-title">元</span>
						</div>
						<div class="amount-box-percentage">
							<Icon type="md-trending-up" size='28' color="#0ea391" v-if="itemData.salesChangeAmount>0"/>
							<Icon type="md-trending-down" size='28' color="orange" v-else/>
						</div>
						<div class="amount-box-percentage"
							:style="{'color':itemData.salesChangeAmount>0 ? '#0ea391':'orange'}">
							{{itemData.salesChangeAmount}}
							<span class="amount-box-title">元</span>
						</div>
						<div class="amount-box-desc">{{'比上一'+currentDate+(itemData.salesChangeAmount>0 ? '上升':'下降')}}
						</div>
					</div>
				</div>
				<div class="flex-item-50">
					<div class="amount-box">
						<div class="amount-box-title">销售成本</div>
						<div class="text-overflow amount-box-amount">
							￥{{itemData.salesCost}}
							<span class="amount-box-title">元</span>
						</div>
						<div class="amount-box-percentage">
							<Icon type="md-trending-up" size='28' color="#0ea391" v-if="itemData.costChangeAmount>0"/>
							<Icon type="md-trending-down" size='28' color="orange" v-else/>
						</div>
						<div class="amount-box-percentage"
							:style="{'color':itemData.costChangeAmount>0 ? '#0ea391':'orange'}">
							{{itemData.costChangeAmount}}
							<span class="amount-box-title">元</span>
						</div>
						<div class="amount-box-desc">{{'比上一'+currentDate+(itemData.costChangeAmount>0 ? '上升':'下降')}}
						</div>
					</div>
				</div>
			</div>
			<div class="uni-row">
				<div class="flex-item-50">
					<div class="amount-box">
						<div class="amount-box-title">销售利润</div>
						<div class="text-overflow amount-box-amount">
							￥{{itemData.salesProfit}}
							<span class="amount-box-title">元</span>
						</div>
						<div class="amount-box-percentage">
							<Icon type="md-trending-up" size='28' color="#0ea391" v-if="itemData.profitChangeAmount>0"/>
							<Icon type="md-trending-down" size='28' color="orange" v-else/>
						</div>
						<div class="amount-box-percentage"
							:style="{'color':itemData.profitChangeAmount>0 ? '#0ea391':'orange'}">
							{{itemData.profitChangeAmount}}
							<span class="amount-box-title">元</span>
						</div>
						<div class="amount-box-desc">{{'比上一'+currentDate+(itemData.profitChangeAmount>0 ? '上升':'下降')}}
						</div>
					</div>
				</div>
				<div class="flex-item-50">
					<div class="amount-box">
						<div class="amount-box-title">退货金额</div>
						<div class="text-overflow amount-box-amount">
							￥{{itemData.returnAmount}}
							<span class="amount-box-title">元</span>
						</div>
						<div class="amount-box-percentage">
							<Icon type="md-trending-up" size='28' color="#0ea391" v-if="itemData.returnChangeAmount>0"/>
							<Icon type="md-trending-down" size='28' color="orange" v-else/>
						</div>
						<div class="amount-box-percentage"
							:style="{'color':itemData.returnChangeAmount>0 ? '#0ea391':'orange'}">
							{{itemData.returnChangeAmount}}
							<span class="amount-box-title">元</span>
						</div>
						<div class="amount-box-desc">{{"比上一"+currentDate+(itemData.returnChangeAmount>0 ? '上升':'下降')}}
						</div>
					</div>
				</div>
			</div>
			<div class="uni-row">
				<div class="flex-item-50">
					<div class="amount-box">
						<div class="amount-box-title">收款金额</div>
						<div class="text-overflow amount-box-amount">
							￥{{itemData.receiptAmount}}
							<span class="amount-box-title">元</span>
						</div>
						<div class="amount-box-percentage">
							<Icon type="md-trending-up" size='28' color="#0ea391" v-if="itemData.receiptChangeAmount>0"/>
							<Icon type="md-trending-down" size='28' color="orange" v-else/>
						</div>
						<div class="amount-box-percentage"
							:style="{'color':itemData.receiptChangeAmount>0 ? '#0ea391':'orange'}">
							{{itemData.receiptChangeAmount}}
							<span class="amount-box-title">元</span>
						</div>
						<div class="amount-box-desc">{{'比上一'+currentDate+(itemData.receiptChangeAmount>0 ? '上升':'下降')}}
						</div>
					</div>
				</div>
				<div class="flex-item-50">
					<div class="amount-box">
						<div class="amount-box-title">付款金额</div>
						<div class="text-overflow amount-box-amount">
							￥{{itemData.paymentAmount}}
							<span class="amount-box-title">元</span>
						</div>
						<div class="amount-box-percentage">
							<Icon type="md-trending-up" size='28' color="#0ea391" v-if="itemData.paymentChangeAmount>0"/>
							<Icon type="md-trending-down" size='28' color="orange" v-else/>
						</div>
						<div class="amount-box-percentage"
							:style="{'color':itemData.paymentChangeAmount>0 ? '#0ea391':'orange'}">
							{{itemData.paymentChangeAmount}}
							<span class="amount-box-title">元</span>
						</div>
						<div class="amount-box-desc">{{'比上一'+currentDate+(itemData.paymentChangeAmount>0 ? '上升':'下降')}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import formatDate from '@/utils/formatDate'
	import dateUtil from '@/utils/dateUtil'

	export default {
		name: 'businessanalysis',
		components: {},
		data() {
			return {
				themeBgColor:'#ff6a7f',
				currentDate: '日',
				searchItems: {
					totalBusinessDate: [
						dateUtil.startTime(dateUtil.getBeginToday()).replace(" 00:00:00", ""),
						dateUtil.endTime(dateUtil.getBeginToday()).replace(" 23:59:59", "")
					],
					trendBusinessDate: [
						dateUtil.startTime(dateUtil.getYesterday()),
						dateUtil.endTime(dateUtil.getYesterday())
					]
				},
				itemData: {
					salesAmount: 0,
					salesChangeAmount: 0,
					returnAmount: 0,
					returnChangeAmount: 0,
					receiptAmount: 0,
					receiptChangeAmount: 0,
					paymentAmount: 0,
					paymentChangeAmount: 0,
					salesCost: 0,
					costChangeAmount: 0,
					salesProfit: 0,
					profitChangeAmount: 0
				},
				pickerStatus:false
			}
		},

		methods: {
			initItemData() {
				let self = this
				request.post('/api/Home/GetBusinessAnalysis', this.searchItems).then(function(result) {
					if (result.state != 1) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取分析失败"
						});
						return
					}
					self.itemData = result.data
				}).catch(err => {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "获取分析失败"
					});
				})
			},
			getAnalysisResult(innerHtml) {
				this.currentDate = innerHtml
				let self = this;
				switch (innerHtml) {
					case '日':
						self.searchItems.totalBusinessDate = [];
						self.searchItems.totalBusinessDate.push(dateUtil.startTime(dateUtil.getBeginToday()).replace(
							" 00:00:00", ""));
						self.searchItems.totalBusinessDate.push(dateUtil.endTime(dateUtil.getBeginToday()).replace(
							" 23:59:59",
							""));
						self.searchItems.trendBusinessDate = [];
						self.searchItems.trendBusinessDate.push(dateUtil.startTime(dateUtil.getYesterday()));
						self.searchItems.trendBusinessDate.push(dateUtil.endTime(dateUtil.getYesterday()));
						break;
					case '周':
						self.searchItems.totalBusinessDate = [];
						self.searchItems.totalBusinessDate.push(dateUtil.getBeginWeek().replace(" 00:00:00", ""));
						self.searchItems.totalBusinessDate.push(dateUtil.getEndWeek().replace(" 23:59:59", ""));
						self.searchItems.trendBusinessDate = [];
						self.searchItems.trendBusinessDate.push(dateUtil.getBeginLastWeek(self.searchItems
							.totalBusinessDate[0]));
						self.searchItems.trendBusinessDate.push(dateUtil.getEndLastWeek(self.searchItems
							.totalBusinessDate[0]));
						break;
					case '月':
						self.searchItems.totalBusinessDate = [];
						self.searchItems.totalBusinessDate.push(dateUtil.getBeginMonth().replace(" 00:00:00", ""));
						self.searchItems.totalBusinessDate.push(dateUtil.getEndMonth().replace(" 23:59:59", ""));
						self.searchItems.trendBusinessDate = [];
						self.searchItems.trendBusinessDate.push(dateUtil.getBeginLastMonth(self.searchItems
							.totalBusinessDate[0]));
						self.searchItems.trendBusinessDate.push(dateUtil.getEndLastMonth(self.searchItems
							.totalBusinessDate[0]));
						break;
					case '年':
						self.searchItems.totalBusinessDate = [];
						self.searchItems.totalBusinessDate.push(dateUtil.getCurrentYearStartDate().replace(" 00:00:00",
							""));
						self.searchItems.totalBusinessDate.push(dateUtil.getCurrentYearEndDate().replace(" 23:59:59", ""));
						self.searchItems.trendBusinessDate = [];
						self.searchItems.trendBusinessDate.push(dateUtil.getLastYearStartDate(self.searchItems
							.totalBusinessDate[0]));
						self.searchItems.trendBusinessDate.push(dateUtil.getLastYearEndDate(self.searchItems
							.totalBusinessDate[0]));
						break;
					default:
						this.openPicker();
						return;
				}
				this.initItemData();
			},
			lastDate(innerHtml) {
				let self = this
				let date
				switch (innerHtml) {
					case '日':
						if (self.searchItems.totalBusinessDate.length > 1) {
							date = self.searchItems.totalBusinessDate[0]
							self.searchItems.totalBusinessDate = []
							self.searchItems.totalBusinessDate.push(dateUtil.startTime(dateUtil.getYesterday(date))
								.replace(
									" 00:00:00", ""))
							self.searchItems.totalBusinessDate.push(dateUtil.endTime(dateUtil.getYesterday(date)).replace(
								" 23:59:59", ""))
							self.searchItems.trendBusinessDate = [];
							self.searchItems.trendBusinessDate.push(dateUtil.startTime(dateUtil.getYesterday(self
								.searchItems.totalBusinessDate[0])));
							self.searchItems.trendBusinessDate.push(dateUtil.endTime(dateUtil.getYesterday(self.searchItems
								.totalBusinessDate[0])));
						}
						break;
					case '周':
						if (self.searchItems.totalBusinessDate.length > 1) {
							date = self.searchItems.totalBusinessDate[0]
							self.searchItems.totalBusinessDate = []
							self.searchItems.totalBusinessDate.push(dateUtil.getBeginLastWeek(date)
								.replace(" 00:00:00", ""))
							self.searchItems.totalBusinessDate.push(dateUtil.getEndLastWeek(date)
								.replace(" 23:59:59", ""))
							self.searchItems.trendBusinessDate = [];
							self.searchItems.trendBusinessDate.push(dateUtil.getBeginLastWeek(self.searchItems
								.totalBusinessDate[0]));
							self.searchItems.trendBusinessDate.push(dateUtil.getEndLastWeek(self.searchItems
								.totalBusinessDate[0]))
						}
						break;
					case '月':
						if (self.searchItems.totalBusinessDate.length > 1) {
							date = self.searchItems.totalBusinessDate[0]
							self.searchItems.totalBusinessDate = []
							self.searchItems.totalBusinessDate.push(dateUtil.getBeginLastMonth(date)
								.replace(" 00:00:00", ""))
							self.searchItems.totalBusinessDate.push(dateUtil.getEndLastMonth(date)
								.replace(" 23:59:59", ""))
							self.searchItems.trendBusinessDate = [];
							self.searchItems.trendBusinessDate.push(dateUtil.getBeginLastMonth(self.searchItems
								.totalBusinessDate[0]));
							self.searchItems.trendBusinessDate.push(dateUtil.getEndLastMonth(self.searchItems
								.totalBusinessDate[0]));
						}
						break;
					case '年':
						if (self.searchItems.totalBusinessDate.length > 1) {
							date = self.searchItems.totalBusinessDate[0]
							self.searchItems.totalBusinessDate = []
							self.searchItems.totalBusinessDate.push(dateUtil.getLastYearStartDate(date)
								.replace(" 00:00:00", ""))
							self.searchItems.totalBusinessDate.push(dateUtil.getLastYearEndDate(date)
								.replace(" 23:59:59", ""))
							self.searchItems.trendBusinessDate = [];
							self.searchItems.trendBusinessDate.push(dateUtil.getLastYearStartDate(self.searchItems
								.totalBusinessDate[0]));
							self.searchItems.trendBusinessDate.push(dateUtil.getLastYearEndDate(self.searchItems
								.totalBusinessDate[0]));
						}
						break;
					default:
						return;
				}
				this.initItemData();
			},
			nextDate(innerHtml) {
				let self = this;
				let date;
				switch (innerHtml) {
					case '日':
						if (self.searchItems.totalBusinessDate.length > 1) {
							date = self.searchItems.totalBusinessDate[0]
							self.searchItems.totalBusinessDate = []
							self.searchItems.totalBusinessDate.push(dateUtil.startTime(dateUtil.getNextday(date)).replace(
								" 00:00:00", ""))
							self.searchItems.totalBusinessDate.push(dateUtil.endTime(dateUtil.getNextday(date)).replace(
								" 23:59:59", ""))
							self.searchItems.trendBusinessDate = [];
							self.searchItems.trendBusinessDate.push(dateUtil.startTime(dateUtil.getYesterday(self
								.searchItems.totalBusinessDate[0])));
							self.searchItems.trendBusinessDate.push(dateUtil.endTime(dateUtil.getYesterday(self.searchItems
								.totalBusinessDate[0])));
						}
						break;
					case '周':
						if (self.searchItems.totalBusinessDate.length > 1) {
							date = self.searchItems.totalBusinessDate[0]
							self.searchItems.totalBusinessDate = []
							self.searchItems.totalBusinessDate.push(dateUtil.getBeginNextWeek(date)
								.replace(" 00:00:00", ""))
							self.searchItems.totalBusinessDate.push(dateUtil.getEndNextWeek(date)
								.replace(" 23:59:59", ""))
							self.searchItems.trendBusinessDate = [];
							self.searchItems.trendBusinessDate.push(dateUtil.getBeginLastWeek(self.searchItems
								.totalBusinessDate[0]));
							self.searchItems.trendBusinessDate.push(dateUtil.getEndLastWeek(self.searchItems
								.totalBusinessDate[0]));
						}
						break;
					case '月':
						if (self.searchItems.totalBusinessDate.length > 1) {
							date = self.searchItems.totalBusinessDate[0]
							self.searchItems.totalBusinessDate = []
							self.searchItems.totalBusinessDate.push(dateUtil.getBeginNextMonth(date)
								.replace(" 00:00:00", ""))
							self.searchItems.totalBusinessDate.push(dateUtil.getEndNextMonth(date)
								.replace(" 00:00:00", ""))
							self.searchItems.trendBusinessDate = [];
							self.searchItems.trendBusinessDate.push(dateUtil.getBeginLastMonth(self.searchItems
								.totalBusinessDate[0]));
							self.searchItems.trendBusinessDate.push(dateUtil.getEndLastMonth(self.searchItems
								.totalBusinessDate[0]));
						}
						break;
					case '年':
						if (self.searchItems.totalBusinessDate.length > 1) {
							date = self.searchItems.totalBusinessDate[0]
							self.searchItems.totalBusinessDate = []
							self.searchItems.totalBusinessDate.push(dateUtil.getNextYearStartDate(date)
								.replace(" 00:00:00", ""))
							self.searchItems.totalBusinessDate.push(dateUtil.getNextYearEndDate(date)
								.replace(" 23:59:59", ""))
							self.searchItems.trendBusinessDate = [];
							self.searchItems.trendBusinessDate.push(dateUtil.getLastYearStartDate(self.searchItems
								.totalBusinessDate[0]));
							self.searchItems.trendBusinessDate.push(dateUtil.getLastYearEndDate(self.searchItems
								.totalBusinessDate[0]));
						}
						break;
					default:
						return;
				}
				this.initItemData();
			},
			pickerChange(val) {
				if(val[0] && val[1]){
					this.searchItems.totalBusinessDate = [];
					this.searchItems.totalBusinessDate.push(dateUtil.startTime(val[0]).replace(" 00:00:00", ""));
					this.searchItems.totalBusinessDate.push(dateUtil.endTime(val[1]).replace(" 23:59:59", ""));
					this.searchItems.trendBusinessDate = dateUtil.getLastCustomCycle(val[0], val[1]);
					this.initItemData();
				}
			},
			pickerClear(val){
				this.pickerStatus = false;
			},
			pickerOk(val){
				this.pickerStatus = false;
			},
			openPicker(val){
				this.pickerStatus = false;
				let self = this
				setTimeout(function(){
					self.pickerStatus = true;
				},300)
			}
		},
		watch: {},
		created: function() {
			this.initItemData();
		}
	}
</script>

<style scoped>
	.layout {
		border-radius: 8px;
	}

	.amount-box {
		background-color: white;
		padding: 30px;
	}

	.amount-box-title {
		margin-left: 5px;
		font-size: 14px;
		text-align: left;
		color: rgb(204, 215, 220);
	}

	.amount-box-amount {
		font-size: 30px;
		text-align: left;
	}

	.amount-box-percentage {
		font-size: 20px;
		text-align: center;
	}

	.amount-box-desc {
		text-align: center;
		color: rgb(204, 215, 220);
	}
	.uni-row{
		overflow: hidden;
	}
	.flex-item-20{
		float: left;
		width: 20%;
		text-align: center;
		padding: 5px;
		cursor:pointer;
	}
	.head-1{
		background-color: #fff;
		color: #000;
		border-radius: 5px 5px 0px 0px;
		border-bottom: 2px solid #ff6a7f;
	}
	.head-2{
		background-color: #fff;
		color: #000;
		border-radius: 5px;
	}
	.flex-item-50{
		float: left;
		width: 50%;
		text-align: center;
		padding: 5px;
	}
	.flex-item-60{
		float: left;
		width: 60%;
		text-align: center;
		padding: 5px;
	}
</style>